import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Typography } from '../Typography';
import * as S from './ErrorComponent.styles';

export function ErrorComponent({ icon = ['fal', 'question-circle'], title = 'Uh oh, something went wrong.', description = 'Try going back to the previous page or contact us for more information.' }) {
	return (
		<S.EmptyWrapper>
			<S.InfoWrapper>
				<FontAwesomeIcon icon={icon} />
			</S.InfoWrapper>
			<Typography tag="h5" weight="semibold" center>
				{title}
			</Typography>
			<Typography tag="p" variation="2" center>
				{description}
			</Typography>
		</S.EmptyWrapper>
	);
}

ErrorComponent.propTypes = {
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
	title: PropTypes.string,
	description: PropTypes.string,
};
